webpackJsonp([248379863452744],{

/***/ 1343:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AlertInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"color","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-alert-input-8742bb76641ec7351041.js